import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { QueryFilter, QUERY_FILTER_MARKET } from 'src/component/shared';
import { MoneyFullBRL } from 'src/services';

import { Typography, Paper, LinearProgress } from "@material-ui/core";


// tslint:disable-next-line:no-empty-interface
export interface IMarketCoverPriceProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketCoverPriceState {
    customFilter: {
        isChart: boolean
    },
}

const MARKET_COVER_PRICE = gql`
query marketPriceCoverPrice($customFilter: MarketShareCustomFilter) {
    marketPriceCoverPrice(marketShareCustomFilter: $customFilter) {
        current_year,
		last_year
    }
}
`;

export class MarketCoverPrice extends React.Component<IMarketCoverPriceProps, IMarketCoverPriceState> {
    constructor(props: IMarketCoverPriceProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          }
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };
  
        return (
            <Query query={QUERY_FILTER_MARKET} notifyOnNetworkStatusChange={true}>
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                    return (
                        <Query query={MARKET_COVER_PRICE} variables={QueryFilter.getFilterMarket(clientC, jsonFilter, [], false)}>
                            {({ loading, error, data}) => {
                                return this.dataToRend(data, cache, loading);
                            }}
                        </Query>
                    )
                    
                }}
            </Query>
        )
    }

    private dataToRend (data:any, cache:any, loading:any) {
        return (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Capa Médio
                </Typography>
                {cache.loading && <LinearProgress />}
                {loading && <LinearProgress />}
                <Typography component="p" className="big-number">
                    {data && data.marketPriceCoverPrice && MoneyFullBRL(data.marketPriceCoverPrice[0].current_year)}
                </Typography>
                <Typography component="p" className="comparative transparent">
                    -
                </Typography>
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/price/cover-price/MarketCoverPrice.tsx